import React, { useState } from 'react';
import api from '../../services/api';
import './LoginPage.css';

export default function LoginPage({ onLoginSuccess }) {
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const resp = await api.post('/auth/login', { email, password });
      const { access_token, user } = resp.data;
      localStorage.setItem('fraudlens_auth_token', access_token);
      localStorage.setItem('fraudlens_user', JSON.stringify(user));
      onLoginSuccess(user);
    } catch (err) {
      setError(err.response?.data?.detail || 'Login failed. Check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        {/* Logo */}
        <div className="login-logo">
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
            <path
              d="M12 2L3 7v10l9 5 9-5V7L12 2z"
              stroke="#7c5cfc"
              strokeWidth="1.5"
              fill="rgba(124,92,252,0.12)"
              strokeLinejoin="round"
            />
            <path d="M12 8l-4 2.5v5L12 18l4-2.5v-5L12 8z" fill="#7c5cfc" opacity="0.7" />
          </svg>
        </div>

        <h1 className="login-title">FraudLens</h1>
        <p className="login-subtitle">Invoice Intelligence Platform</p>

        <form onSubmit={handleSubmit} className="login-form" noValidate>
          <label className="login-label" htmlFor="email">Email</label>
          <input
            id="email"
            className="login-input"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@company.com"
            required
            autoFocus
            autoComplete="email"
          />

          <label className="login-label" htmlFor="password">Password</label>
          <input
            id="password"
            className="login-input"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
            required
            autoComplete="current-password"
          />

          {error && <div className="login-error" role="alert">{error}</div>}

          <button className="login-btn" type="submit" disabled={loading}>
            {loading ? (
              <span className="login-btn-inner">
                <span className="login-spinner" />
                Signing in…
              </span>
            ) : (
              'Sign In'
            )}
          </button>
        </form>

        <p className="login-hint">
          Contact your administrator to request access.
        </p>
      </div>
    </div>
  );
}
